var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApproachRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 497,
    viewBox: "0 0 266 497",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M17.2086 46.6642L52.6646 117.569C94.5288 201.239 91.4253 307.386 45.0484 382.41C22.7295 418.467 5.76313 445.944 5.76313 445.944C-10.4595 471.937 15.6212 509.518 38.0172 491.881L236.328 336.418C253.665 323.383 263.23 300.542 264.914 276.442C267.359 248.801 258.887 219.754 240.233 200.628L51.9697 7.22316C30.9389 -14.5559 2.53329 17.251 17.2635 46.5807L17.2086 46.6642Z",
    fill: "#E3F2FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproachRightArrow);
export default __webpack_public_path__ + "static/media/approach-right-arrow.037d14ba88a336ac3acd3c7126685340.svg";
export { ForwardRef as ReactComponent };